// El mensaje que lleva lo que se le pasó al Brain con el clip (brain-multimodal,
// D3). Lo que dice la imagen o el audio va **dentro del mensaje**, como texto:
// así queda en el historial y el Brain puede volver a ello en el turno
// siguiente, sin guardar el archivo en ningún sitio (D4).
//
// Pero quien escribió no tiene por qué ver la descripción entera en su propia
// burbuja: la pantalla enseña qué adjuntó, y el resto queda para el Brain (3.5).

const MARK = '\n\n[Adjunto: '

export function withAttachment(text: string, name: string, content: string): string {
  return `${text}${MARK}${name}]\n${content}`
}

/** El texto que escribió la persona y, si lo hay, el nombre de lo adjuntado. */
export function splitAttachment(content: string): { text: string; attachment: string | null } {
  const at = content.indexOf(MARK)
  if (at < 0) return { text: content, attachment: null }
  const rest = content.slice(at + MARK.length)
  return { text: content.slice(0, at), attachment: rest.slice(0, rest.indexOf(']')) }
}

/** Lo más largo que viaja un documento leído solo para la conversación (D6,
 *  R10): lo mismo que un resultado de herramienta. Va en el mensaje y se
 *  relee en cada turno siguiente, así que uno de cien páginas encarecería la
 *  conversación entera. */
export const ATTACHMENT_TEXT_MAX = 16000

export function capped(text: string, note: string): string {
  return text.length <= ATTACHMENT_TEXT_MAX ? text : `${text.slice(0, ATTACHMENT_TEXT_MAX)}\n\n${note}`
}
